<template>
    <div id="tokenUsage" class="capacity-flow-manage">
        <SideNav></SideNav>
        <div class="gr-content-container">
            <top-header>
                <div slot="setup-header-left" class="setup-header-left">
                    <span class="setup-header-left-icon">
                        <i class="el-icon-coin"></i>
                    </span>
                    <span>{{$t('tokenUsage.title')}}</span>
                </div>
                <div class="setup-header-right-l" slot="setup-header-right-l">
                    <div class="sd-main-list">
                        <el-select
                            v-model="corpId"
                            size="small"
                            @change="changeCorpId"
                            :placeholder="$t('common.selectPlaceholder')">
                            <el-option
                                v-for="item in mainOptions"
                                :key="item.corpId"
                                :label="item.corpName"
                                :value="item.corpId">
                                <img
                                    height="12px"
                                    v-if="item.corpType == 0"
                                    src="https://static.guoranbot.com/cdn-arsenal/dev/img/qiyechat.b7289a96.png"
                                    alt=""
                                    srcset=""/>
                                <img
                                    height="12px"
                                    v-if="item.corpType == 3"
                                    src="https://static.guoranbot.com/cdn-arsenal/dev/img/dingding.874450b3.jpeg"
                                    alt=""
                                    srcset=""/>
                                <span style="display: inline-block;margin-left: 6px;color: #8492a6;font-size: 13px;">
                                    {{ item.corpName }}
                                </span>
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </top-header>
            <div class="content">
                <div class="manage-nav-section">
                    <ManangeNav></ManangeNav>
                </div>
                <div class="content-section">
                    <div class="token-usage-content-box">
                        <div class="header-action-row">
                            <!-- 左侧统计面板 -->
                            <div class="stats-panel">
                                <div class="stat-card total">
                                    <div class="stat-info">
                                        <div class="stat-label">总 Token 消耗</div>
                                        <div class="stat-value">{{ formatNumber(stats.totalTokens) }}</div>
                                    </div>
                                    <i class="el-icon-data-analysis stat-icon"></i>
                                </div>
                                <div class="stat-card prompt">
                                    <div class="stat-info">
                                        <div class="stat-label">Prompt</div>
                                        <div class="stat-value">{{ formatNumber(stats.promptTokens) }}</div>
                                    </div>
                                    <i class="el-icon-chat-dot-round stat-icon"></i>
                                </div>
                                <div class="stat-card completion">
                                    <div class="stat-info">
                                        <div class="stat-label">Completion</div>
                                        <div class="stat-value">{{ formatNumber(stats.completionTokens) }}</div>
                                    </div>
                                    <i class="el-icon-message stat-icon"></i>
                                </div>
                            </div>

                            <!-- 右侧高级搜索 -->
                            <div class="advanced-search-container">
                                <el-popover
                                    placement="bottom-end"
                                    width="400"
                                    trigger="click"
                                    v-model="searchVisible"
                                >
                                    <div class="search-form-wrapper">
                                        <h4 class="search-title">高级搜索</h4>
                                        <el-form :model="searchForm" size="small" label-width="80px">
                                            <el-form-item :label="$t('tokenUsage.requestTitle')">
                                                <el-select v-model="searchForm.requestTitleKeyword" placeholder="请选择事项" clearable style="width: 100%">
                                                    <el-option v-for="item in requestTitles" :key="item" :label="item" :value="item"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item :label="$t('tokenUsage.modelName')">
                                                <el-select v-model="searchForm.modelId" placeholder="请选择模型" clearable style="width: 100%">
                                                    <el-option v-for="item in models" :key="item" :label="item" :value="item"></el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="时间范围">
                                                <el-date-picker
                                                    v-model="dateRange"
                                                    type="datetimerange"
                                                    range-separator="至"
                                                    start-placeholder="开始"
                                                    end-placeholder="结束"
                                                    value-format="timestamp"
                                                    @change="handleDateChange"
                                                    style="width: 100%"
                                                >
                                                </el-date-picker>
                                            </el-form-item>
                                            <div class="search-form-btns">
                                                <el-button size="small" @click="handleReset">重置</el-button>
                                                <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                                            </div>
                                        </el-form>
                                    </div>
                                    <el-button slot="reference" type="primary" size="small" icon="el-icon-search">
                                        高级搜索
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                </el-popover>
                                <el-button size="small" icon="el-icon-refresh" style="margin-left: 10px" @click="handleRefresh"></el-button>
                            </div>
                        </div>

                        <div class="table-container">
                            <el-table
                                :data="usageLogs"
                                style="width: 100%"
                                height="100%"
                                v-loading="loading"
                                border
                            >
                                <el-table-column prop="requestTitleZh" :label="$t('tokenUsage.requestTitle')" width="150" show-overflow-tooltip align="center"></el-table-column>
                                <el-table-column prop="modelName" :label="$t('tokenUsage.modelName')" min-width="250" align="center"></el-table-column>
                                <el-table-column prop="totalTokens" :label="$t('tokenUsage.totalTokens')" width="120" align="center" sortable></el-table-column>
                                <el-table-column prop="promptTokens" :label="$t('tokenUsage.promptTokens')" width="100" align="center"></el-table-column>
                                <el-table-column prop="completionTokens" :label="$t('tokenUsage.completionTokens')" width="120" align="center"></el-table-column>
                                <el-table-column prop="startTime" :label="$t('tokenUsage.startTime')" width="170" align="center">
                                    <template slot-scope="scope">
                                        {{ formatDate(scope.row.startTime) }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="endTime" :label="$t('tokenUsage.endTime')" width="170" align="center">
                                    <template slot-scope="scope">
                                        {{ formatDate(scope.row.endTime) }}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('tokenUsage.userName')" width="120" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.userName || scope.row.userId }}
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('tokenUsage.operate')" width="100" fixed="right" align="center">
                                    <template slot-scope="scope">
                                        <el-button type="text" size="small" @click="showDetail(scope.row)">{{$t('tokenUsage.detail')}}</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div class="pagination-container">
                            <el-pagination
                                @current-change="handleCurrentChange"
                                @size-change="handleSizeChange"
                                :current-page="pageNo"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="pageSize"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-drawer
            :title="$t('tokenUsage.drawerTitle')"
            :visible.sync="drawerVisible"
            size="50%"
            direction="rtl"
            append-to-body
        >
            <div class="detail-drawer-content" v-if="activeRow">
                <el-collapse v-model="activeNames">
                    <el-collapse-item title="Request Payload" name="request">
                        <pre class="payload-pre">{{ JSON.stringify(activeRow.requestPayload, null, 2) }}</pre>
                    </el-collapse-item>
                    <el-collapse-item title="Response Payload" name="response">
                        <pre class="payload-pre">{{ JSON.stringify(activeRow.responsePayload, null, 2) }}</pre>
                    </el-collapse-item>
                </el-collapse>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import TopHeader from "../../../components/top-header.vue";
import SideNav from "../../menu/SideNav.vue";
import ManangeNav from "../../menu/ManageNave.vue";
import dayjs from 'dayjs';

export default {
    name: "tokenUsage",
    components: {
        TopHeader,
        SideNav,
        ManangeNav,
    },
    data() {
        return {
            loading: false,
            searchVisible: false,
            drawerVisible: false,
            activeRow: null,
            activeNames: ['request', 'response'],
            corpId: "",
            mainOptions: [],
            stats: {
                totalTokens: 0,
                promptTokens: 0,
                completionTokens: 0,
            },
            models: [],
            requestTitles: [],
            searchForm: {
                requestTitleKeyword: '',
                modelId: '',
                startTimeBegin: null,
                startTimeEnd: null,
            },
            dateRange: [],
            usageLogs: [],
            pageNo: 1,
            pageSize: 20,
            total: 0,
        };
    },
    mounted() {
        this.getCorps4main();
        this.fetchData();
    },
    methods: {
        getCorps4main() {
            this.$http.get(this.requestUrl.accountManage.corps4main).then((res) => {
                if (res.data && res.data.code === "0") {
                    this.mainOptions = res.data.data;
                    if (this.mainOptions.length != 0) {
                        this.corpId = this.mainOptions[0].corpId;
                    }
                }
            });
        },
        changeCorpId(val) {
            this.corpId = val;
            this.handleSearch();
        },
        showDetail(row) {
            this.activeRow = row;
            this.drawerVisible = true;
        },
        handleDateChange(val) {
            if (val) {
                this.searchForm.startTimeBegin = val[0];
                this.searchForm.startTimeEnd = val[1];
            } else {
                this.searchForm.startTimeBegin = null;
                this.searchForm.startTimeEnd = null;
            }
        },
        handleSearch() {
            this.pageNo = 1;
            this.searchVisible = false;
            this.fetchData();
        },
        handleRefresh() {
            this.fetchData();
        },
        handleReset() {
            this.searchForm = {
                requestTitleKeyword: '',
                modelId: '',
                startTimeBegin: null,
                startTimeEnd: null,
            };
            this.dateRange = [];
            this.pageNo = 1;
            this.fetchData();
        },
        fetchData() {
            this.loading = true;
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchForm
            };
            this.$http.post(this.requestUrl.tokenUsage.getTokenUsageLogs, params).then(res => {
                if (res.data && res.data.code === '0') {
                    const data = res.data.data;
                    this.usageLogs = data.records || [];
                    this.total = data.total || 0;
                    
                    // 更新统计和筛选选项
                    this.stats.totalTokens = data.totalTokens || 0;
                    this.stats.promptTokens = data.promptTokens || 0;
                    this.stats.completionTokens = data.completionTokens || 0;
                    this.models = data.models || [];
                    this.requestTitles = data.requestTitles || [];
                } else {
                    this.$message.error(res.data.message || '获取数据失败');
                }
            }).catch(err => {
                console.error(err);
                this.$message.error('网络错误');
            }).finally(() => {
                this.loading = false;
            });
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.fetchData();
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.pageNo = 1;
            this.fetchData();
        },
        formatDate(timestamp) {
            if (!timestamp) return '-';
            return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss');
        },
        formatNumber(num) {
            if (num === null || num === undefined) return 0;
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
};
</script>

<style lang="less" scoped>
@import "./../../../assets/less/capacityAndFlowManage/capacityFlowManage.less";

.capacity-flow-manage {
    .content-section {
        .token-usage-content-box {
            padding: 16px;
            height: 100%;
            display: flex;
            flex-direction: column;
            background-color: #f5f8fb;

            .header-action-row {
                display: flex;
                justify-content: space-between;
                align-items: flex-end;
                margin-bottom: 16px;

                .stats-panel {
                    display: flex;
                    gap: 16px;
                    flex: 1;

                    .stat-card {
                        flex: 1;
                        max-width: 240px;
                        height: 80px;
                        padding: 15px 20px;
                        border-radius: 8px;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        position: relative;
                        overflow: hidden;
                        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
                        transition: transform 0.3s;

                        &:hover {
                            transform: translateY(-2px);
                        }

                        .stat-info {
                            z-index: 1;
                            .stat-label {
                                font-size: 13px;
                                color: rgba(255, 255, 255, 0.85);
                                margin-bottom: 4px;
                            }
                            .stat-value {
                                font-size: 22px;
                                font-weight: bold;
                                color: #fff;
                            }
                        }

                        .stat-icon {
                            font-size: 40px;
                            color: rgba(255, 255, 255, 0.2);
                            position: absolute;
                            right: 10px;
                            bottom: -5px;
                        }

                        &.total {
                            background: linear-gradient(135deg, #366aff 0%, #50a1ff 100%);
                        }
                        &.prompt {
                            background: linear-gradient(135deg, #10b981 0%, #34d399 100%);
                        }
                        &.completion {
                            background: linear-gradient(135deg, #8b5cf6 0%, #a78bfa 100%);
                        }
                    }
                }

                .advanced-search-container {
                    flex: none;
                    display: flex;
                    align-items: center;
                }
            }

            .table-container {
                flex: 1;
                background-color: #fff;
                border-radius: 8px;
                overflow: hidden;
                box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
            }

            .pagination-container {
                padding: 12px 0;
                text-align: right;
            }
        }
    }
}

.search-form-wrapper {
    padding: 10px;
    .search-title {
        margin: 0 0 15px;
        font-size: 16px;
        color: #333;
        border-bottom: 1px solid #eee;
        padding-bottom: 10px;
    }
    .search-form-btns {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid #eee;
    }
}

.detail-drawer-content {
    padding: 20px;
    height: calc(100vh - 80px);
    overflow-y: auto;
    
    .payload-pre {
        background: #1e1e1e;
        color: #dcdcdc;
        padding: 16px;
        border-radius: 6px;
        font-family: "Fira Code", monospace;
        font-size: 12px;
        line-height: 1.6;
        overflow-x: auto;
        white-space: pre-wrap;
    }
}
</style>
